import { Button, Grid, Paper, Typography } from "@material-ui/core";
import classnames from "classnames";
import React from "react";
import { Link } from "react-router-dom";

// styles
import useStyles from "./styles";

// logo
import logo from "./logo.svg";

export default function Error() {
  var classes = useStyles();

  return (
    <Grid container className={classes.container} style={{backgroundColor:"lightgrey"}}>
      <div className={classes.logotype}>
        <Typography variant="h3" color="white" className={classes.logotypeText}>
          INSAF - CMSF
        </Typography>
      </div>
      <Paper classes={{ root: classes.paperRoot }}>
        <Typography
          variant="h1"
          color="primary"
          className={classnames(classes.textRow, classes.errorCode)}
        >
          401
        </Typography>
        <Typography variant="h5" color="primary" className={classes.textRow}>
          You are not authorized to access this resource.
        </Typography>
        <Typography
          variant="h6"
          color="text"
          colorBrightness="secondary"
          className={classnames(classes.textRow, classes.safetyText)}
        >
          But we're here to bring you back to safety
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/"
          size="large"
          className={classes.backButton}
        >
          Back to Home
        </Button>
      </Paper>
    </Grid>
  );
}
